import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SpsPruefstatus, pruefstatusText } from '../../../../../Models/Sps';

export interface SpsBemerkungDialogData {
  signalName: string;
  adresse: string | null;
  status: SpsPruefstatus;
  bemerkung: string;
  /** Bei „Nicht OK“ ist eine Fehlerbeschreibung Pflicht. */
  pflicht: boolean;
}

/**
 * Kleiner Dialog für die Schnellprüfung in der Tabelle: beim Wechsel auf
 * „Nicht OK“ verlangt das Backend eine Fehlerbeschreibung. Liefert die
 * Bemerkung oder null (abgebrochen).
 */
@Component({
  selector: 'app-sps-bemerkung-dialog',
  template: `
    <h2 mat-dialog-title>{{ statusText }} – Bemerkung</h2>

    <mat-dialog-content>
      <p class="signal">
        <strong>{{ data.signalName || '–' }}</strong>
        <span *ngIf="data.adresse" class="adresse">{{ data.adresse }}</span>
      </p>

      <p class="hinweis" *ngIf="data.pflicht">
        Bei „Nicht OK“ ist eine Fehlerbeschreibung erforderlich, damit der Prüfverlauf nachvollziehbar bleibt.
      </p>

      <mat-form-field appearance="outline" class="feld">
        <mat-label>{{ data.pflicht ? 'Fehlerbeschreibung' : 'Bemerkung' }}</mat-label>
        <textarea matInput cdkFocusInitial [(ngModel)]="bemerkung" rows="4" maxlength="4000"
          placeholder="z. B. Signal schaltet beim Betätigen des Tasters nicht."></textarea>
        <mat-hint align="end">{{ bemerkung.length }} / 4000</mat-hint>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="abbrechen()">Abbrechen</button>
      <button mat-raised-button color="primary" type="button" (click)="uebernehmen()" [disabled]="!gueltig">
        Speichern
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content { width: 440px; max-width: 100%; }
    .signal { display: flex; flex-wrap: wrap; gap: 8px; align-items: baseline; margin: 0 0 8px; }
    .adresse { font-family: ui-monospace, Consolas, monospace; color: #666; }
    .hinweis { margin: 0 0 12px; font-size: 13px; color: #666; }
    .feld { width: 100%; }
  `]
})
export class SpsBemerkungDialogComponent {

  bemerkung: string;

  constructor(
    private dialogRef: MatDialogRef<SpsBemerkungDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: SpsBemerkungDialogData
  ) {
    this.bemerkung = data.bemerkung ?? '';
  }

  get statusText(): string {
    return pruefstatusText(this.data.status);
  }

  get gueltig(): boolean {
    return !this.data.pflicht || this.bemerkung.trim().length > 0;
  }

  abbrechen(): void {
    this.dialogRef.close(null);
  }

  uebernehmen(): void {
    if (this.gueltig) {
      this.dialogRef.close(this.bemerkung.trim());
    }
  }
}
